module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/PhotographicBackground-134c0c53f8281cee5e0604ad417c13ce.jpg";